import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Stack} from "@mui/material";
import {isMobile} from "react-device-detect";
import {toast} from "@lb/mlib-components";

export default function AlertDialog(props) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const dialogWidth = isMobile ? "xl" : "sm";

    return (
        <div>
            <Stack direction={"row"}
                   justifyContent="center"
                   alignItems="center"
                   spacing={1}>
                {props.message.length > 0 && <Button color="inherit" onClick={handleClickOpen}>
                    Details
                </Button>}
                <Button color="inherit" onClick={() => toast.close(props.key)}>
                    Dismiss
                </Button>
            </Stack>

            <Dialog
                fullWidth maxWidth={dialogWidth}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Error details"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.message}
                    </DialogContentText>
                </DialogContent>

            </Dialog>
        </div>
    )
        ;
}
